import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcReviewDto } from './model.dto'
import { BaseModelDto } from '../../base/baseModel.dto'

@ObjectType()
export class ArcReviewSiteDto extends BaseModelDto {
  @Field(type => ArcReviewDto, { nullable: true })
  review?: ArcReviewDto

  @Field(t => Int)
  reviewId!: number

  @Field(t => Int)
  status!: number

  @Field()
  statusDate!: Date

  @Field()
  state!: number

  @Field(t => Int)
  site!: number

  @Field({ nullable: true })
  link?: string

  @Field({ nullable: true })
  statusReason?: string

  @Field({ nullable: true })
  exempt?: boolean
}
